import { render, staticRenderFns } from "./PopupApplyForMatching.vue?vue&type=template&id=4b6f10c3&scoped=true"
import script from "./PopupApplyForMatching.vue?vue&type=script&lang=js"
export * from "./PopupApplyForMatching.vue?vue&type=script&lang=js"
import style0 from "./PopupApplyForMatching.vue?vue&type=style&index=0&id=4b6f10c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6f10c3",
  null
  
)

export default component.exports